


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, DollarSign, CreditCard, AlertCircle } from "lucide-react";
import logo from "./logo.png";
import { Api } from "../Api/Api";

const StaffDashboard = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    totalCustomers: 0,
    activeCustomers: 0,
    closedCustomers: 0,
    totalInvestment: 0,
    totalInterestGenerated: 0,
    totalPendingInterest: 0,
    totalExpenses: 0,
    profit: 0,
    pendingPayments: 0,
    weeklyTotalActiveAmount: 0, // ✅ NEW
    totalRemainingAdvance: 0,
    todayDueAmount: 0,
  });


  const isTodayDue = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();

    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffDays = Math.floor((today - start) / 86400000);

    return diffDays >= 0 && diffDays % 7 === 0;
  };


  useEffect(() => {
    const user = localStorage.getItem("currentUser");
    if (!user) {
      navigate("/login");
      return;
    }
    loadDashboardData();
  }, []);

  /* SAME WEEK LOGIC */
  const getCompletedWeeks = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();
    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((today - start) / 86400000);
    return Math.floor(diffDays / 7);
  };

  const loadDashboardData = async () => {
    let weeklyTotalActiveAmount = 0;
    let todayDueAmount = 0;

    try {
      /* FETCH DATA */
     
      const custRes = await fetch(`${Api}customers/list.php`);
      const custData = await custRes.json();

      const payRes = await fetch(`${Api}payments/list.php`);
      const payData = await payRes.json();

      const expRes = await fetch(`${Api}expenses/list.php`);
      const expData = await expRes.json();

      const advRes = await fetch(`${Api}advances/list.php`);
const advData = await advRes.json();
const advances = advData.advances || [];



      const customers = custData.customers || [];
      const payments = payData.payments || [];
      const expenses = expData.expenses || [];

      /* CALCULATIONS */
      let totalInvestment = 0;
      let totalInterestGenerated = 0;
      let totalPendingInterest = 0;
      let totalExpenses = 0;

      // EXPENSE TOTAL
      expenses.forEach((e) => {
        totalExpenses += Number(e.amount || 0);
      });

    
// customers.forEach((c) => {
   customers
    .filter((c) => c.status === "Active")
    .forEach((c) => {
  const weekly = Number(c.weekly_interest_amount || 0);
  const completedWeeks = getCompletedWeeks(c.given_date);

  totalInvestment += Number(c.investment_amount || 0);

  // ✅ ADD THIS
  if (c.status === "Active") {
    weeklyTotalActiveAmount += weekly;
  }

  const customerPayments = payments.filter(
    (p) => Number(p.customer_id) === Number(c.id),
  );

  const totalPaid = customerPayments.reduce(
    (sum, p) => sum + Number(p.paid_amount || 0),
    0,
  );

  totalInterestGenerated += totalPaid;

  const totalDue = completedWeeks * weekly;
  const pending = Math.max(totalDue - totalPaid, 0);

  totalPendingInterest += pending;

  if (isTodayDue(c.given_date)) {
    const weekly = Number(c.weekly_interest_amount || 0);

    const customerPayments = payments.filter(
      (p) => Number(p.customer_id) === Number(c.id),
    );

    const completedWeeks = getCompletedWeeks(c.given_date);

    const alreadyPaid = customerPayments.some(
      (p) => Number(p.week_number) === completedWeeks,
    );

    if (!alreadyPaid) {
      todayDueAmount += weekly;
    }
  }
});

      const activeCustomers = customers.filter(
        (c) => c.status === "Active",
      ).length;

      const closedCustomers = customers.filter(
        (c) => c.status === "Close",
      ).length;

      const profit = totalInterestGenerated - totalExpenses;

      let totalRemainingAdvance = 0;

advances.forEach((a) => {
  const total = Number(a.advance_amount || 0);
  const used = Number(a.used_amount || 0);
  const remaining = total - used;

  if (remaining > 0) {
    totalRemainingAdvance += remaining;
  }
});


      setStats({
        totalCustomers: customers.length,
        activeCustomers,
        closedCustomers,
        totalInvestment,
        totalInterestGenerated,
        totalPendingInterest,
        totalExpenses,
        profit,
        pendingPayments: 0,
        weeklyTotalActiveAmount, // ✅ ADD
        totalRemainingAdvance,
        todayDueAmount,
      });
    } catch (err) {
      console.error("Dashboard Error:", err);
    }
  };

  const KPICard = ({ title, value, icon: Icon, color }) => (
    <div className="p-6 bg-white rounded-xl shadow">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm text-gray-600 font-medium">{title}</p>
          {/* <p className="text-2xl font-bold text-gray-900 mt-2">{value}</p> */}
          <p className="text-2xl font-bold text-gray-900 mt-2 break-all leading-tight">
  {value}
</p>

        </div>
        <div className={`p-3 rounded-lg ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </div>
  );

  return (
    <div className="relative min-h-screen p-6 bg-gray-100 overflow-hidden">
      {/* WATERMARK */}

      <div className="relative z-10 space-y-8">
        {/* HEADER */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            <span className="text-blue-600">SAL</span> Dashboard
          </h1>
          <p className="text-black mt-1">Customer financial overview</p>
        </div>

        {/* KPI ROW 1 */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6"> */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <KPICard
            title="Total Customers"
            value={stats.totalCustomers}
            icon={Users}
            color="bg-blue-600"
          />
          <KPICard
            title="Active Customers"
            value={stats.activeCustomers}
            icon={Users}
            color="bg-green-600"
          />
          <KPICard
            title="Closed Customers"
            value={stats.closedCustomers}
            icon={Users}
            color="bg-gray-600"
          />
          {/* <KPICard
            title="Total Investment"
            value={`₹${stats.totalInvestment.toLocaleString()}`}
            icon={DollarSign}
            color="bg-indigo-600"
          /> */}
          <KPICard
            title="Pending Interest"
            value={`₹${stats.totalPendingInterest.toLocaleString()}`}
            icon={AlertCircle}
            color="bg-red-600"
          />
          <KPICard
            title="Weekly Total"
            value={`₹${stats.weeklyTotalActiveAmount.toLocaleString()}`}
            icon={CreditCard}
            color="bg-teal-600"
          />
          <KPICard
            title="Remaining Advance"
            value={`₹${stats.totalRemainingAdvance.toLocaleString()}`}
            icon={CreditCard}
            color="bg-orange-600"
          />
        </div>

        {/* KPI ROW 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* <KPICard
            title="Interest Generated (Before Expenses)"
            value={`₹${stats.totalInterestGenerated.toLocaleString()}`}
            icon={CreditCard}
            color="bg-purple-600"
          /> */}

          <KPICard
            title="Today Incoming Due"
            value={`₹${stats.todayDueAmount.toLocaleString()}`}
            icon={DollarSign}
            color="bg-yellow-600"
          />
          <KPICard
            title="Total Expenses"
            value={`₹${stats.totalExpenses.toLocaleString()}`}
            icon={AlertCircle}
            color="bg-black"
          />
          {/* <KPICard
            title="Net Profit"
            value={`₹${stats.profit.toLocaleString()}`}
            icon={DollarSign}
            color={stats.profit >= 0 ? "bg-green-700" : "bg-red-700"}
          /> */}
        </div>
      </div>

      <img
        src={logo}
        alt="Watermark"
        className="
          absolute inset-0 m-auto
          w-[700px]
          opacity-20
          pointer-events-none
          z-50
          grayscale
          brightness-150
          contrast-75
        "
      />
    </div>
  );
};

export default StaffDashboard;

